import React from 'react';
import { defaultFiltersForDates } from 'pages/Dashboard/components/constant';
import { INVOICE_COUNT_DATA } from 'pages/Dashboard/components/DashboardGraphQL';
import { useQuery } from '@apollo/client';
import Loader from 'components/common/Loader';
import LineChart from '../../../LineChart';

const TransportationChart = ({ selectedOption }) => {
  const { data, loading, error } = useQuery(INVOICE_COUNT_DATA, {
    variables: defaultFiltersForDates(selectedOption),
    fetchPolicy: 'network-only',
  });

  if (error) return `There is an error on this page : ${error.message} `;
  if (loading)
    return (
      <div className="linechart-loader">
        <Loader />
      </div>
    );

  const combinedKeysSet = new Set();
  let firstLineData = [];
  let secondLineData = [];

  if (data?.invoiceCountData?.PAID_FULL?.length) {
    firstLineData = data.invoiceCountData.PAID_FULL.map((val) => {
      combinedKeysSet.add(val[defaultFiltersForDates(selectedOption).groupOn]);
      return val.count;
    });
  }
  if (data?.invoiceCountData?.INVOICE_UNPAID?.length) {
    secondLineData = data.invoiceCountData.INVOICE_UNPAID.map((val) => {
      combinedKeysSet.add(val[defaultFiltersForDates(selectedOption).groupOn]);
      return val.count;
    });
  }

  const combinedKeys = Array.from(combinedKeysSet);
  return (
    <>
      {' '}
      <LineChart
        combinedKeys={combinedKeys}
        firstLineData={firstLineData}
        secondLineData={secondLineData}
        firstHeading="Fully Paid"
        secondHeading="Unpaid"
      />
    </>
  );
};

export default TransportationChart;

// import React from 'react';
// import { defaultFiltersForDates, formatXAxisLabels } from 'pages/Dashboard/components/constant';
// import { INVOICE_COUNT_DATA } from 'pages/Dashboard/components/DashboardGraphQL';
// import { useQuery } from '@apollo/client';
// import Loader from 'components/common/Loader';
// import LineChart from '../../../LineChart';

// const TransportationChart = ({ selectedOption }) => {
//   const { data, loading, error } = useQuery(INVOICE_COUNT_DATA, {
//     variables: defaultFiltersForDates(selectedOption),
//     fetchPolicy: 'network-only',
//   });

//   if (error) return `There is an error on this page : ${error.message} `;
//   if (loading)
//     return (
//       <div className="linechart-loader">
//         <Loader />
//       </div>
//     );

//   let firstLineData = [];
//   let secondLineData = [];

//   // Get X-axis labels based on selected option
//   const xAxisLabels = formatXAxisLabels(selectedOption);

//   if (data?.invoiceCountData?.PAID_FULL?.length) {
//     firstLineData = data.invoiceCountData.PAID_FULL.map((val) => val.count);
//   }
//   if (data?.invoiceCountData?.INVOICE_UNPAID?.length) {
//     secondLineData = data.invoiceCountData.INVOICE_UNPAID.map((val) => val.count);
//   }

//   // Pad arrays to match X-axis labels length
//   while (firstLineData.length < xAxisLabels.length) {
//     firstLineData.push(0);
//   }
//   while (secondLineData.length < xAxisLabels.length) {
//     secondLineData.push(0);
//   }

//   return (
//     <LineChart
//       combinedKeys={xAxisLabels}
//       firstLineData={firstLineData}
//       secondLineData={secondLineData}
//       firstHeading="Fully Paid"
//       secondHeading="Unpaid"
//     />
//   );
// };

// export default TransportationChart;
